import { ServiceCardInfoCardProps } from "../../../../data-model/authLetterSuccessModel";

/**
 * Compact card showing a single service/J-code identifier.
 *
 * @param props.code - Service/J-code identifier.
 */
const ServiceCardInfoCard = ({ code }: ServiceCardInfoCardProps) => {
  const BASE_CLASS_NAME = "service-card-info-card-container";
  return (
    <div
      className={`${BASE_CLASS_NAME} flex flex-col gap-1 rounded bg-primaryGray-16 px-3 py-2`}
    >
      <div
        className={`${BASE_CLASS_NAME}__header text-x-tiny font-semiBold text-primaryGray-1`}
      >
        Code: {code}
      </div>
      {/* <div
        className={`${BASE_CLASS_NAME}__details text-overline text-primaryGray-6`}
      >
        {description}
      </div> */}
    </div>
  );
};

export default ServiceCardInfoCard;
